import React, { useEffect, useState } from "react";
import { DataCodeEnum } from "../../../../../constants/enum";
import DataContent from "../../../../../components/DataContent";

const LifePathNumber: React.FC = () => {
  return (
    <DataContent
      code={DataCodeEnum.THE_MEANING_OF_LIFE_PATH_NUMBER_AND_DESTINY_NUMBER}
      name="The meaning of Life Path Number and Destiny Number"
      fields={[
        {
          code: "name",
          name: "Name",
        },
        {
          code: "description",
          name: "Description",
        },
      ]}
    />
  );
};

export default LifePathNumber;
